import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["assetDetails", "addressField", "balanceHint", "institutionField", "maskField"]

  declare assetDetailsTarget: HTMLElement
  declare addressFieldTarget: HTMLElement
  declare balanceHintTarget: HTMLElement
  declare institutionFieldTarget: HTMLElement
  declare maskFieldTarget: HTMLElement
  declare hasAssetDetailsTarget: boolean
  declare hasAddressFieldTarget: boolean
  declare hasBalanceHintTarget: boolean
  declare hasInstitutionFieldTarget: boolean
  declare hasMaskFieldTarget: boolean

  connect() {
    this.toggle()
  }

  toggle() {
    const select = this.element.querySelector<HTMLSelectElement>("select[name*='account_subtype']")
    if (!select) return

    const value = select.value
    const isOtherAsset = value.endsWith("-other_asset")
    const isProperty = value === "property-other_asset"

    if (this.hasAssetDetailsTarget) {
      this.assetDetailsTarget.classList.toggle("hidden", !isOtherAsset)
    }

    if (this.hasAddressFieldTarget) {
      this.addressFieldTarget.classList.toggle("hidden", !isProperty)
    }

    if (this.hasInstitutionFieldTarget) {
      this.institutionFieldTarget.classList.toggle("hidden", isOtherAsset)
    }

    if (this.hasMaskFieldTarget) {
      this.maskFieldTarget.classList.toggle("hidden", isOtherAsset)
    }

    if (this.hasBalanceHintTarget) {
      if (isOtherAsset) {
        this.balanceHintTarget.textContent = "For other assets, enter the current estimated value"
      } else if (value.endsWith("-credit") || value.endsWith("-loan")) {
        this.balanceHintTarget.textContent = "For loans and credit cards, enter the amount owed as a positive number"
      } else {
        this.balanceHintTarget.textContent = ""
      }
    }
  }
}
